export enum Actions {
  Print,
  Download,
  Clone,
  Move,
  Archive,
  Delete,
  StopPublishing,
  Publish,
  Restore,
}
